"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var markInputRule_1 = __importDefault(require("../lib/markInputRule"));

var Mark_1 = __importDefault(require("./Mark"));

function backticksFor(node, side) {
  var ticks = /`+/g;
  var match;
  var len = 0;

  if (node.isText) {
    while (match = ticks.exec(node.text)) {
      len = Math.max(len, match[0].length);
    }
  }

  var result = len > 0 && side > 0 ? " `" : "`";

  for (var i = 0; i < len; i++) {
    result += "`";
  }

  if (len > 0 && side < 0) {
    result += " ";
  }

  return result;
}

var Code = /*#__PURE__*/function (_Mark_1$default) {
  _inherits(Code, _Mark_1$default);

  var _super = _createSuper(Code);

  function Code() {
    _classCallCheck(this, Code);

    return _super.apply(this, arguments);
  }

  _createClass(Code, [{
    key: "inputRules",
    value: function inputRules(_ref) {
      var type = _ref.type;
      return [markInputRule_1.default(/(?:^|[^`])(`([^`]+)`)$/, type)];
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Mod`": prosemirror_commands_1.toggleMark(type)
      };
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        mark: "code_inline"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "code_inline";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        excludes: "_",
        parseDOM: [{
          tag: "code"
        }],
        toDOM: function toDOM() {
          return ["code", {
            spellCheck: false
          }];
        }
      };
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {
        open: function open(_state, _mark, parent, index) {
          return backticksFor(parent.child(index), -1);
        },
        close: function close(_state, _mark, parent, index) {
          return backticksFor(parent.child(index - 1), 1);
        },
        escape: false
      };
    }
  }]);

  return Code;
}(Mark_1.default);

exports.default = Code;